export default __webpack_public_path__ + "static/media/notebook.5d085ab0.jpg";